
<!--  [style]="{width:'{{width}}'; minWidth:'{{minWidth}}';}" -->
 <p-dialog header="Search" [(visible)]="showSearch">
    <ng-content></ng-content>
   <ng-template #footer>
    <div class="grid flex-row flex-wrap gap-3 align-content-center justify-content-start" style="padding: 10px;">
        <button mat-raised-button (click)="reset.emit()" type="button" class="btn btn-primary pull-left">Reset</button>
        <button mat-raised-button (click)="search.emit();hide()" type="button" class="btn btn-primary pull-right">Close</button>
        <button mat-raised-button (click)="search.emit()" type="button" class="btn btn-primary pull-right">Search</button>
        <div class="clearfix"></div>
    </div>
     </ng-template>
</p-dialog>
